import Advertising from "./advertising";

export default Advertising;